<template lang="pug">
b-modal#themeColor(
  ref="themeColor"
  :title="$t('ui.color')"
  centered
  no-fade
  no-close-on-backdrop
  hide-footer
  :busy="loading"
  size="lg"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row(v-if="item != null")
      .col-12
        .card.mb-0
          .card-header
            .row.col-12
              .form-group.col-12
                b-input-group(size="sm")
                  b-input-group-text.border-0(slot="prepend")
                    i.fas.fa-palette
                    span.ml-2  {{ item.provider_type }} - {{ item.theme_code }}
              .form-group.col-12(v-if="isAdmin && isEditAccess")
                b-button(@click="onAdd(item.theme_code)" type="button" variant="info" size="sm")
                  i.fa.fa-plus
                  span.ml-1 {{ $t("ui.combine.add_color") }}
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="8%")
                          span(:title="$t('ui.color')") {{ $t('ui.color') }}
                        th.text-center(width="5%" v-if="isAdmin && isEditAccess")
                          span(:title="$t('ui.action')") {{ $t('ui.action') }}
                    tbody.clusterize-content
                      tr(v-if="themeColorList.length == 0")
                        td(colspan="7").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in themeColorList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="item.theme_color") {{ item.theme_color }}
                        td.actions.text-center.align-middle(v-if="isAdmin && isEditAccess")
                          span.mr-2
                            a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-primary(
                              href="javascript:void(0)"
                              @click="onEdit(item)"
                              :title="$t('ui.edit')"
                              )
                          span
                            a.fa.fa-trash.btn.btn-ssm.btn-icon.btn-danger(
                              href="javascript:void(0)"
                              @click="onDelete(item)"
                              :title="$t('ui.delete')"
                              )

    .row
      .col
        b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}

  addthemecolor(ref="addThemeColor" @clicked="addThemeColor" :item="addColor" @failed="handleFailedColor")
  editthemecolor(ref="editThemeColor" :itemColor="selectedThemeColor" @clicked="afterEditColor" @failed="handleFailedColor")
</template>

<script>
import config from "@/config";
import ThemeProviderTypeLookup from "@/library/ThemeProviderTypeLookup";
import addthemecolor from "@/components/content/theme/addThemeColor.vue";
import editthemecolor from "@/components/content/theme/editThemeColor.vue";

export default {
  components: {
    ThemeProviderTypeLookup,
    addthemecolor,
    editthemecolor
  },
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      themeColorList: [],
      addColor: null,
      selectedThemeColor: null,
      provider_type: '',
      theme_name: '',
      theme_code: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    accountType() {
      return this.$store.getters.accountType;
    },
    isAdmin() {
      return this.$store.getters.accountType === 5;
    },
    isAdminMaster() {
      return [3,5].includes(this.$store.getters.accountType);
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_theme");
    }
  },
  methods: {
    onAdd(e) {
      this.addColor = e;
      this.$refs.addThemeColor.$refs.addThemeColor.show();
    },
    onEdit(e) {
      e.theme_code = this.item.theme_code
      this.selectedThemeColor = e;
      this.$refs.editThemeColor.$refs.editThemeColor.show();
    },
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.provider_type = "";
      this.theme_name = "";
      this.theme_code = "";
    },
    shown() {
      this.getThemeColorList();
    },
    getThemeColorList() {
      let url = config.getThemeColorListUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: this.item.theme_code
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.themeColorList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    addThemeColor() {
      this.getThemeColorList();

      this.$helpers.showDialog(this.$t("ui.combine.add_color"), this.$t("message.success"), "success");
    },
    afterEditColor(item) {
      this.getThemeColorList();
      this.$helpers.showDialog(this.$t("ui.combine.edit_color"), this.$t("message.success"), "success");
    },
    onDelete(e) {
      this.$swal({
        title: this.$t("ui.delete"),
        text: this.$t("message.delete_color_confirm", { color: e.theme_color }),
        type: "info",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          this.confirmDelete(e);
        }
      });
    },
    confirmDelete: function(e) {
      let url = config.deleteThemeColorUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        theme_code: e.theme_code,
        theme_color: e.theme_color
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getThemeColorList();
                this.$helpers.showDialog(this.$t("ui.delete"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    handleFailedColor(tag, status) {
      this.$helpers.showDialog(this.$t("ui." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
